import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileInput } from '../../../FlowConfigurationInputs';

function External({ action }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.OPEN.';
    const options = {
        fileInput: {
            checkExtension: () => {
                return true;
            },
            fileType: '*'
        }
    }
    return (
        <div>
            <div className="form-element">
                {t(label + 'FILE-PATH')}
                <FileInput action={action} inputName="filePath" options={options.fileInput} isRequired={false} isSize={true} />
            </div>
        </div>
    )
}

export default External;
